/**
 * A field control that can't be edited right now is in one of two states, and
 * they must not look alike:
 *
 * - Read-only: the value is locked (a read-only field, a row with inline
 *   editing turned off, no permission). It reads as plain data: full-strength
 *   value, default cursor, no hover tint, chevron or hover actions. Dimming it
 *   made a locked value look missing or still loading next to the full-strength
 *   text cells in the same row.
 * - Unavailable: the control is briefly out of reach, for example while its
 *   value saves. It dims until it comes back.
 *
 * Pickers take both `readOnly` and `disabled`; either stops interaction, and
 * `readOnly` wins the styling. Hover affordances should be gated on
 * `isFieldInteractive` rather than overridden with this class.
 */
export const READ_ONLY_FIELD_CLASS = 'cursor-default'

export const UNAVAILABLE_FIELD_CLASS = 'cursor-not-allowed opacity-50'

interface FieldLockState {
  disabled?: boolean
  readOnly?: boolean
}

export function fieldLockClass({
  disabled,
  readOnly,
}: FieldLockState): string | undefined {
  if (readOnly) return READ_ONLY_FIELD_CLASS
  if (disabled) return UNAVAILABLE_FIELD_CLASS
  return undefined
}

export function isFieldInteractive({
  disabled,
  readOnly,
}: FieldLockState): boolean {
  return !disabled && !readOnly
}
